import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChatMessagesState, Message } from "./types";

/** Store data about the chat messages */
export const chatMessages = createSlice({
  name: "chatMessages",
  initialState: {
    messages: [],
    showChat: false,
    unreadCount: 0,
  } as ChatMessagesState,
  reducers: {
    addChatMessage: (state, { payload }: PayloadAction<Message>) => {
      state.messages = [
        ...state.messages,
        {
          ...payload,
        },
      ];
      state.unreadCount++;
    },
    toggleChat: (state, { payload }: PayloadAction<boolean>) => {
      return {
        ...state,
        showChat: payload,
        unreadCount: 0
      };
    }
  },
});

export const { addChatMessage, toggleChat } =
  chatMessages.actions;

export default chatMessages.reducer;
